var needmodal = document.getElementById('needhelp');
var howtomodal = document.getElementById('howtomeasure');

var needbtn = document.getElementById('needhelpbtn');
var howtobtn = document.getElementById('howmeasurebtn');

var needspan = document.getElementsByClassName('custom-close')[0];
var howtospan = document.getElementsByClassName('how-custom-close')[0];

needbtn.onclick = function () {
  needmodal.style.display = 'block';
};
howtobtn.onclick = function () {
  howtomodal.style.display = 'block';
};

needspan.onclick = function () {
  needmodal.style.display = 'none';
};
howtospan.onclick = function () {
  howtomodal.style.display = 'none';
};

//When the user clicks anywhere outside of the modal, close it
window.addEventListener('click', function (event) {
  if (event.target == howtomodal) {
    howtomodal.style.display = 'none';
  }
  if (event.target == needmodal) {
    needmodal.style.display = 'none';
  }
});

